<template>
  <div class=" mt-4">

    <div class="container">

      <div class="row">
        <div class="col-xs-12 ">
          <br>
          <div class="tab-content" id="nav-tabContent">
            <div>
              <div v-if="items.length ===0" class="empty-container">
                <div class="empty-container__icon">
                  <i class="fas fa-film"></i>
                </div>
                <div class="empty-container__title">
                  <h3>There are no flixes</h3>
                </div>
                <div class="empty-container__subtitle">
                  <p>There are no flixes from this creator yet!</p>
                </div>
              </div>
              <div class="row mb-30-none ajaxLoad" v-if="items.length>0">
                <h3 class=" mb-4" style="letter-spacing: 2px">Flixes</h3>
                <div class="col-md-12 col-12" v-for="item in items" :id="`flix-${item.id}`">
                  <reel
                      :name="item.creator.name"
                      :title="item.title"
                      :description="item.description"
                      :time="new Date(item.created_at).toDateString()"
                      :thumbnail="item.watch ? '' : item.image ? item.image : ''"
                      :portrait="item.image"
                      :video="item.video && item.video != '' ? item.video : null"
                      :likes="item.likesCount"
                      :comments="item.commentsCount"
                      :profile="item.creator.image"
                      :auth="auth ? 1 : 0"
                      :item-id="item.id"
                      :images="item.images"
                      :liked="item.isLiked"
                      :locked="item.watch ? 0 : 1"
                  ></reel>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Reel from "./reel.vue";
import axios from "axios";

export default {
  name: "flix",
  components: {Reel},
  props: ["flixesUrl", "auth"],
  data() {
    return {
      items: [],
      page: 1,
      loading: false,
      finished: false,
      error: false,
    };
  },
  methods: {
    async loadData() {
      // Check for if query param flix is available and if available, get it's value
      const urlParams = new URLSearchParams(window.location.search);
      const flix = urlParams.get("flix");

      if (this.loading || this.finished) return;
      this.loading = true;
      this.$Progress.start();
      try {
        const response = await axios.get(this.flixesUrl + '?page=' + this.page+(flix?`&flix_id=${flix}`:''));
        if (response.data.data.length > 0) {
          this.items = this.items.concat(response.data.data);
          this.page++;
        } else {
          this.finished = true;
        }
        this.$Progress.finish();
      } catch (e) {
        this.$Progress.fail();
        this.error = true;
        notify("error", "Please, check your internet and try again");
      } finally {
        this.loading = false;

      }

    },
    scroll() {
      if (this.finished) return;
      window.onscroll = async () => {
        const scrolledHeight = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight;
        const documentHeight = document.documentElement.offsetHeight;
        if (Math.floor(scrolledHeight) >= Math.floor(documentHeight * 2 / 3)) {
          await this.loadData();
        }
      }
    },

    checkScroll() {
      // console.log("scrolling")
      const el = this.$refs.scrollContainer;
      if (el.scrollHeight - el.scrollTop === el.offsetHeight) {
        console.log('End of element reached');
      }
    },
    handleScroll(event) {
      // Any code to be executed when the window is scrolled
      // console.log("scrolling", event);
    }
  },
  created() {
    this.loadData();
  },

  mounted() {
    this.scroll();
  }
}
</script>

<style lang="scss" scoped>
.empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px 20px;
  text-align: center;
  color: #999;
  background-color: #0e0d12;
  border-radius: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  border: solid 1px #1e1e24;
  @media screen and (max-width: 900px) {
    & {
      padding: 10px 10px;
      margin-top: 10px;
      margin-bottom: 10px;

    }
  }

  @media screen and (max-width: 480px) {
    & {
      padding: 20px 10px;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }

  .empty-container__icon {
    font-size: 50px;
    margin-bottom: 20px;

    @media screen and (max-width: 480px) {
      & {
        font-size: 40px;
        margin-bottom: 10px;
      }
    }
  }

  .empty-container__title {
    font-size: 20px;
    margin-bottom: 10px;
    @media screen and (max-width: 480px) {
      & {
        font-size: 15px;
        margin-bottom: 5px;
      }
    }
  }

  .empty-container__subtitle {
    font-size: 14px;
    @media screen and (max-width: 480px) {
      & {
        font-size: 12px;
      }
    }
  }
}
</style>